import { DashboardData } from '@/dashboard/shared/types/types';

export const getDefaultDashboardData = (): DashboardData => {
  return {
    dashboardId: -1,
    dashboardGroupId: -1,
    dashboardName: '',
    image: '/dashboard/dashboard-default.png',
    preset: false,
    shared: false,
    sharing: false,
    startScreen: false,
    createUser: false,
    featuredReport: false,
    customReport: false,
    dashboardOption: {
      showTimePeriod: true,
      periodRange: 'none',
      alertActivation: true,
      onlyTargetName: true,
    },
    iconId: '',
    creator: {
      name: '',
      activeId: '',
      roleId: '-1',
      profileImage: '',
    },
  };
};
